<template>
    <div class="badge badge-green inline-flex items-center space-x-2">
        <div class="space-x-1">
            <span v-if="address.city">{{ address.city }},</span>
            <span v-if="address.region">{{ address.region }}</span>
            <span v-else>{{ address.country }}</span>
        </div>

        <button
            @click.prevent="deleteAddress"
            class="flex items-center hover:text-gray-100 p-1"
        >
            <icon type="x" class="w-4 h-4" />
        </button>
    </div>
</template>

<script>
import useForm from '@/functions/useForm'

export default {
    props: {
        address: {
            type: Object,
            required: true,
        },
        url: {
            type: String,
            required: true,
        }
    },
    data() {
        return {
            form: useForm({})
        }
    },
    methods: {
        deleteAddress() {
            this.form.delete(this.url, {
                onSuccess: () => window.location.assign(window.location.pathname)
            })
        }
    },
    mounted() {
        console.log(window.location.href)
    }
}
</script>
